import React from "react";
import { useCurrency } from "../context/CurrencyContext";
import { useLang } from "../context/LangContext";
import { Coins } from "lucide-react";

export default function CurrencySwitcher() {
  const { code, setCode, list } = useCurrency();
  const { lang } = useLang();
  return (
    <label className="inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg border border-[#E5E1D8] bg-white/70 text-sm">
      <Coins size={14} className="text-[#5C6053]" />
      <select
        data-testid="currency-switcher"
        value={code}
        onChange={(e) => setCode(e.target.value)}
        className="bg-transparent outline-none text-sm cursor-pointer"
        title="Currency"
      >
        {list.map((c) => (
          <option key={c.code} value={c.code}>
            {c.code} — {lang === "ar" ? c.name_ar : c.name_en}
          </option>
        ))}
      </select>
    </label>
  );
}
